import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AccessControlService } from '../services/accessControl.service';

@Injectable({
  providedIn: 'root'
})
export class AccessControlGuard implements CanActivate {
  constructor(
    private accessControlService: AccessControlService,
    private router: Router
    ){}
    canActivate(
      next: ActivatedRouteSnapshot,
      state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

      this.accessControlService.checkItHasRoles().subscribe(resp => {
        if(!resp) {
          return this.router.navigate(["/app/access"]).then(() => false);
        }

      });
      
      return true;
    }
}
